module.exports = __webpack_public_path__ + "static/media/credit.d4788930.svg";